
var sprite = require("/tmp/build_27def88f/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 50 50\" id=\"icons8-document_jax_8b66183f52340524e44a540b9b197ec0\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <g> <path style=\"stroke:none;fill-rule:nonzero;fill:#A6A6A6;fill-opacity:1;\" d=\"M 7 2 L 7 48 L 43 48 L 43 14.59375 L 42.71875 14.28125 L 30.71875 2.28125 L 30.40625 2 Z M 9 4 L 29 4 L 29 16 L 41 16 L 41 46 L 9 46 Z M 31 5.4375 L 39.5625 14 L 31 14 Z M 15 22 L 15 24 L 35 24 L 35 22 Z M 15 28 L 15 30 L 31 30 L 31 28 Z M 15 34 L 15 36 L 35 36 L 35 34 Z\"/> </g> </symbol>";
module.exports = sprite.add(image, "icons8-document_jax_8b66183f52340524e44a540b9b197ec0");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icons8-document.svg
// module id = 1198
// module chunks = 1